import { render, staticRenderFns } from "./PharmaciesOverview.vue?vue&type=template&id=f71f0e52&"
import script from "./PharmaciesOverview.vue?vue&type=script&lang=js&"
export * from "./PharmaciesOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports